// src/components/prescriptions/BrandingForm.jsx
import React from "react";
import VisualBuilder from "./VisualBuilder";
export default function BrandingForm() {
  return <VisualBuilder />;
}